import { READ, FORM_UPDATE } from '../../../../store/type'
import { CREDIT_CARD } from "./type";
export const mutations = {
    [CREDIT_CARD + READ]: (state, { data, fieldInfoList }) => {
        state.data = data
        state.fieldInfoList = fieldInfoList
    }
};